import { createSlice } from '@reduxjs/toolkit';

export type resourceState = {
  resource: any[];
};

const initialState: resourceState = { resource: [] };

const resourceSlice = createSlice({
  name: 'resource',
  initialState: initialState,
  reducers: {
    handleResource(state, action) {
      state.resource = action.payload;
    }
  }
});

export const { handleResource } = resourceSlice.actions;

export const resourceReducer = resourceSlice.reducer;
